import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LeadEffects, leadReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([LeadEffects]), StoreModule.forFeature(`lead`, leadReducer)]
})
export class LeadStateModule {}
